import { api, parseApiError } from './api';
import type {
  Budget,
  BudgetsListResponse,
  CreateBudgetInput,
  UpdateBudgetInput,
} from '@/types/budget';

export const budgetsService = {
  /**
   * Get all budgets for the authenticated user
   */
  async getBudgets(): Promise<BudgetsListResponse> {
    try {
      const response = await api.get<BudgetsListResponse>('/api/budgets');
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },

  /**
   * Create a new budget
   */
  async createBudget(data: CreateBudgetInput): Promise<Budget> {
    try {
      const response = await api.post<Budget>('/api/budgets', data);
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },

  /**
   * Update a budget
   */
  async updateBudget(id: string, data: UpdateBudgetInput): Promise<Budget> {
    try {
      const response = await api.put<Budget>(`/api/budgets/${id}`, data);
      return response.data;
    } catch (error) {
      throw parseApiError(error);
    }
  },

  /**
   * Delete a budget
   */
  async deleteBudget(id: string): Promise<void> {
    try {
      await api.delete(`/api/budgets/${id}`);
    } catch (error) {
      throw parseApiError(error);
    }
  },
};

export default budgetsService;
